<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Add Workflow'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>

    <tidy-card>
      <tidy-row class="no-padding">
        <tidy-text
          [header]="template?.name" />
      </tidy-row>
      <tidy-row class="extra-bottom-padding">
        <tidy-text
          [body]="template?.description" />
      </tidy-row>
      <tidy-row class="vertical-align-center">
        <tidy-image
          [src]="'assets/img/play.svg'"
          class="body-size" />
        <tidy-text
          [header]="'Trigger:'" />
      </tidy-row>
      <tidy-row class="vertical-align-middle">
        <tidy-image
          [src]="template?.trigger?.icon_url" />
        <tidy-text
          [body]="template?.trigger?.name + ' - ' + template?.trigger?.description" />
      </tidy-row>
      <tidy-row class="vertical-align-center">
        <tidy-image
          [src]="'assets/img/check.svg'"
          class="body-size" />
        <tidy-text
          [header]="'Actions:'" />
      </tidy-row>
      @for (action of template?.workflow_template_actions; track action) {
        <tidy-row class="vertical-align-middle">
          <tidy-image
            [src]="action?.action?.icon_url" />
          <tidy-text
            [body]="action?.action?.name + ' - ' + action?.action?.description" />
        </tidy-row>
      }
    </tidy-card>

    <tidy-button
      [text]="'Add Workflow'"
      [action]="boundAddTemplate"
      class="primary" />

  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
